import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, HardHat, Cpu } from "lucide-react";
import { useI18n } from "@/i18n";
import { IMAGES } from "@/lib/media";

const SERVICES = [
  { key: "maintenance", icon: Sparkles, image: IMAGES.service_maintenance, to: "/services/maintenance", accent: "#B95736" },
  { key: "postconstruction", icon: HardHat, image: IMAGES.service_postconstruction, to: "/services/maintenance#details", accent: "#B95736" },
  { key: "it", icon: Cpu, image: IMAGES.service_it, to: "/services/informatique", accent: "#293845" },
];

export default function Services() {
  const { t } = useI18n();
  return (
    <div data-testid="page-services" className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-24">
      <div className="max-w-3xl mb-16">
        <div className="text-[10px] tracking-[0.22em] uppercase text-stone-500 font-mono">{t("services.eyebrow")}</div>
        <h1 className="mt-4 font-serif text-6xl md:text-8xl tracking-tight text-stone-900 leading-[0.9]">{t("services.title")}</h1>
      </div>

      <div className="grid gap-6 md:gap-8 md:grid-cols-3">
        {SERVICES.map((s, idx) => {
          const Icon = s.icon;
          const isLink = true;
          const Wrapper = isLink ? Link : "div";
          const props = isLink ? { to: s.to } : {};
          return (
            <Wrapper
              key={s.key}
              data-testid={`service-card-page-${s.key}`}
              className="group relative flex flex-col overflow-hidden rounded-lg border border-stone-200 bg-white transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl"
              {...props}
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img src={s.image} alt={t(`services.${s.key}.title`)} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm rounded-full px-3 py-1.5 text-[10px] font-mono tracking-widest uppercase flex items-center gap-2">
                  <Icon size={12} style={{ color: s.accent }} /> {t(`services.${s.key}.tag`)}
                </div>
                <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between text-white">
                  <div>
                    <div className="text-[10px] font-mono tracking-widest uppercase opacity-80">0{idx + 1}</div>
                    <h3 className="mt-1 font-serif text-3xl md:text-4xl leading-tight">{t(`services.${s.key}.title`)}</h3>
                  </div>
                  {isLink && (
                    <ArrowRight size={20} className="opacity-70 group-hover:opacity-100 group-hover:translate-x-1 transition-transform" />
                  )}
                </div>
              </div>
            </Wrapper>
          );
        })}
      </div>

      <div className="mt-16 rounded-2xl bg-[#1C1917] text-white p-10 md:p-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <h3 className="font-serif text-3xl md:text-4xl tracking-tight leading-tight">{t("quote.title")}</h3>
          <p className="mt-3 text-stone-300 max-w-lg">{t("quote.subtitle")}</p>
        </div>
        <Link to="/contact" data-testid="services-page-cta" className="btn-primary">
          {t("hero.cta_primary")} <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
